import React from 'react'
import { push } from "gatsby-link"
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link, { navigateTo } from 'gatsby-link'
import { Menu, Contact } from '../'
import Lottie from 'react-lottie';

import logoDesktop from '../../assets/images/mambo-logo-header-desktop.svg'
import logoMobile from '../../assets/images/mambo-logo-header-mobile.svg'
import search from '../../assets/icons/search.svg'
import hamburger from '../../assets/icons/hamburger-open.svg'
import * as mamboOnline from '../../animation/MAMBO_GLOBE_Navigation_Black.json'

import { media, width } from '../../styles/utils'
import { container, bgIcon, padding, hoverState } from '../../styles/global'
import { ribbon } from '../../styles/colors';

let lastScrollY = 0;
let ticking = false;

class Header extends React.Component {

	state = {
		menuOpen: false,
		contactOpen: false,
		scrolled: false
	}

	componentDidMount = () => {
		window.addEventListener('scroll', this.handleScroll);
	}
	
	componentWillUnmount = () => {
		window.removeEventListener('scroll', this.handleScroll);
	}

	toggleAnimation = (active) => {
		this.setState({
			logoHovering: active
		})
	}

	toggleMenu = () => {
		this.setState({
			menuOpen: !this.state.menuOpen,
		}, () => setTimeout(() => {
			this.setState({
				contactOpen: this.state.menuOpen == false ? false : this.state.contactOpen
			})
		}, 350))

		// Lock scroll on body
		document.body.style.overflowY = this.state.menuOpen ?  'auto' : 'hidden';
	}

	handleScroll = () => {
		const { scrolled } = this.state;

		lastScrollY = window.scrollY;

		if (!ticking) {
			window.requestAnimationFrame(() => {
				const fixedPoint = window.innerHeight;

				if (lastScrollY >= fixedPoint && !scrolled) {
					this.setState({
						scrolled: true
					})
				} 

				if (lastScrollY < fixedPoint && scrolled) {
					this.setState({
						scrolled: false
					})
				} 
				

				ticking = false;
			})
	
			ticking = true;
		}
	}


	toggleContact = () => {
		this.setState({
			contactOpen: !this.state.contactOpen
		})
	}

	onLogoClick = () => {
		const { location } = this.props;

		if (location.pathname == '/') {
			// window location change
			navigateTo('/articles/all')
		} else {
			navigateTo('/')
		}
	}
	
	render() {
		const { menuOpen, contactOpen, scrolled } = this.state;

		return (
				<Wrapper
					scrolled={scrolled}
				>
					<Container>

					<MamboOnline
						href="https://www.bigw.com.au/search/?text=mambo&category="
						target="_blank"
						onMouseEnter={() => this.toggleAnimation(true)}
						onMouseLeave={() => this.toggleAnimation(false)}
					>
						<Lottie
							options={{
								animationData: mamboOnline,
								autoplay: false,
							}}
							width={'100%'}
							height={'100%'}
							isStopped={!this.state.logoHovering}
						/>
					</MamboOnline>

						<Logo 
							onClick={this.onLogoClick}
						/>

						<Functions>
							<Search
								onClick={() => navigateTo('/search')}
							/>
							<Hamburger
								onClick={this.toggleMenu}
							/>
						</Functions>		
						
					</Container>

					{/* Mobile Hamburger (Fixed) */}

					<MobileHamburger>
						<Hamburger
							onClick={this.toggleMenu}
						/>
					</MobileHamburger>

					{/* Menu */}

					<Menu
						open={menuOpen}	
						contactOpen={contactOpen}
						toggleMenu={this.toggleMenu}
						toggleContact={this.toggleContact}
						contactData={this.props.contactData}
					/>	

			</Wrapper>
		)
	}
}

const Container = styled.div`
	${container}
	${padding}
	max-width: 1440px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: relative;
	height: 140px;

	${media.phone`
		height: 78px;
		justify-content: center;
	`}
`

const MamboOnline = styled.a`
    display: block;
	height: 70px;
	width: 87px;
	background-image: url(${mamboOnline});
	${bgIcon}
	cursor: pointer;

	${media.phone`
		display: none;
	`}
`

const Logo = styled.div`
	height: 95px;
	max-width: 693px;
	width: 100%;
	background-image: url(${logoDesktop});
	${bgIcon}

	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	cursor: pointer;

	${media.tablet`
		max-width: 460px;
	`}

	${media.phone`	
		background-image: url(${logoMobile});
		height: 55px;
		display: flex;
		position: inherit;
		top: auto;
		left: auto;
		transform: none;
	`}
`

const Functions = styled.div`
	display: flex;

	${media.phone`
		display: none;
	`}
`

const Search = styled.div`
	height: 20px;
	width: 20px;
	background-image: url(${search});
	margin-right: 40px;
	${hoverState}
`

const Hamburger = styled.div`
	height: 19px;
	width: 25px;
	background-image: url(${hamburger});
	${hoverState}
`

// Mobile Hamburger

const MobileHamburger = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	height: 50px;
	border-top: 2px solid black;
	background: white;

	justify-content: center;
	align-items: center;
	z-index: 11;

	display: none;

	${media.phone`
		display: flex;
	`}
`

const Wrapper = styled.div`
	position: fixed;
	background: white;
	z-index: 10;	
	width: 100%;
	top: 0;
	display: flex;
	justify-content: center;

	> *, > * > * {
		transition: all 0.35s ease;
	}	

	${props => {
		if (props.scrolled) return css`
		    @media (min-width: 1024px) {
				${Container} {
					height: 100px;
				}

				${Logo} {
					height: 75px;
				}
			}
		`
	}}
`


export default Header



// WEBPACK FOOTER //
// ./src/components/Header/header.js